import React, { useState } from "react";
import "./OnepageProjectForm.scss";

const OnepageProjectForm = () => {
  const [formData, setFormData] = useState({
    activity: "",
    sections: [],
    logo: "",
    charter: "",
    domain: "",
    hosting: "",
    name: "",
    email: "",
    phone: "",
    captcha: false,
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox" && name === "sections") {
      const updatedSections = checked
        ? [...formData.sections, value]
        : formData.sections.filter((section) => section !== value);
      setFormData({ ...formData, sections: updatedSections });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.scriptales.fr/onepage-devis", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === 1) {
        setStatus({
          message: "Formulaire envoyé avec succès !",
          type: "success",
        });
        setFormData({
          activity: "",
          sections: [],
          logo: "",
          charter: "",
          domain: "",
          hosting: "",
          name: "",
          email: "",
          phone: "",
          captcha: false,
        });
      } else {
        setStatus({
          message: "Erreur lors de l'envoi du formulaire. Veuillez réessayer.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Erreur:", error);
      setStatus({
        message: "Erreur lors de l'envoi du formulaire. Veuillez réessayer.",
        type: "error",
      });
    }
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <h1 className="page-title text-center">Votre site pro passe en mode festival</h1>
        <h3 className="text-center">Description du projet - Offre site Onepage</h3>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="activity">Décrivez votre activité</label>
            <textarea
              id="activity"
              name="activity"
              placeholder="Votre activité, vos services, votre public cible..."
              value={formData.activity}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <fieldset className="form-group">
            <legend>Sélectionnez jusqu’à 4 sections à inclure</legend>
            {[
              "Présentation",
              "Produits / Services",
              "Portfolio",
              "Témoignages",
              "Équipe",
              "Contact",
              "Appel à l'action",
              "Réseaux sociaux",
            ].map((label) => (
              <div key={label} className="checkbox">
                <input
                  type="checkbox"
                  id={label}
                  name="sections"
                  value={label}
                  checked={formData.sections.includes(label)}
                  onChange={handleChange}
                />
                <label htmlFor={label}>{label}</label>
              </div>
            ))}
          </fieldset>

          <fieldset className="form-group">
            <legend>J'ai déjà mon logo</legend>
            {['Oui', 'Non'].map((option) => (
              <div key={option} className="radio">
                <input
                  type="radio"
                  id={`logo-${option}`}
                  name="logo"
                  value={option}
                  checked={formData.logo === option}
                  onChange={handleChange}
                />
                <label htmlFor={`logo-${option}`}>{option}</label>
              </div>
            ))}
          </fieldset>

          <fieldset className="form-group">
            <legend>J'ai une charte graphique ou des couleurs à appliquer ?</legend>
            {['Oui', 'Non'].map((option) => (
              <div key={option} className="radio">
                <input
                  type="radio"
                  id={`charter-${option}`}
                  name="charter"
                  value={option}
                  checked={formData.charter === option}
                  onChange={handleChange}
                />
                <label htmlFor={`charter-${option}`}>{option}</label>
              </div>
            ))}
          </fieldset>

          <fieldset className="form-group">
            <legend>J'ai déjà mon nom de domaine</legend>
            {['Oui', 'Non'].map((option) => (
              <div key={option} className="radio">
                <input
                  type="radio"
                  id={`domain-${option}`}
                  name="domain"
                  value={option}
                  checked={formData.domain === option}
                  onChange={handleChange}
                />
                <label htmlFor={`domain-${option}`}>{option}</label>
              </div>
            ))}
          </fieldset>

          <fieldset className="form-group">
            <legend>J'ai déjà mon hébergement</legend>
            {['Oui', 'Non', 'Je souhaite être conseillé(e)'].map((option) => (
              <div key={option} className="radio">
                <input
                  type="radio"
                  id={`hosting-${option}`}
                  name="hosting"
                  value={option}
                  checked={formData.hosting === option}
                  onChange={handleChange}
                />
                <label htmlFor={`hosting-${option}`}>{option}</label>
              </div>
            ))}
          </fieldset>

          <div className="form-group">
            <label htmlFor="name">Nom</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Votre nom"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Votre email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Téléphone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Votre numéro de téléphone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="captcha-group">
            <input
              type="checkbox"
              id="captcha"
              className="captcha-checkbox"
              name="captcha"
              checked={formData.captcha}
              onChange={handleChange}
              required
            />
            <label htmlFor="captcha" className="captcha-label">
              Je ne suis pas un robot et j'ai pris connaissance de la <a className="link" href="politique-confidentialite">politique de confidentialité</a>.
            </label>
          </div>

          <button type="submit" className="submit-btn">Envoyer</button>
        </form>

        {status.message && (
          <div className={`status-message ${status.type}`}>{status.message}</div>
        )}
      </div>
    </section>
  );
};

export default OnepageProjectForm;
